<template>
  <div class="paginator">
    <slot name="before" />
    <LazyPaginatorView
      v-if="view"
      :view="view"
      class="paginator__view"
      @update-view="(value) => emit('updateView', value)"
    />
    <LazyPaginatorTotalCount
      v-if="totalCount"
      :total-count="totalCount"
      :total-text="totalText"
      class="paginator__total"
    />
    <LazyPaginatorSort
      v-if="sort && sortOptions?.length && sortOptions.length > 1"
      class="paginator__sort"
      :sort="sort"
      :sort-options="sortOptions"
      @update-sort="(value) => emit('updateSort', value)"
    />
    <LazyPaginatorItemsPerPage
      v-if="itemsPerPage && itemsPerPageOptions?.length && itemsPerPageOptions.length > 1"
      class="paginator__items-per-page"
      :items-per-page="itemsPerPage"
      :items-per-page-options="itemsPerPageOptions"
      @update-items-per-page="(value) => $emit('updateItemsPerPage', value)"
    />
    <LazyPaginatorPages
      v-if="currentPage && totalPages && totalPages > 1"
      :current-page="currentPage"
      :total-pages="totalPages"
      class="paginator__pages"
      @update-page="(value) => emit('updatePage', value)"
    />
    <slot name="after" />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  totalCount?: number
  totalText?: string
  currentPage?: number
  totalPages?: number
  itemsPerPage?: number
  itemsPerPageOptions?: number[]
  sort?: string
  sortOptions?: any[]
  view?: 'grid' | 'list'
  surroundActivePage?: 2
}>()

const emit = defineEmits(['updateView', 'updateItemsPerPage', 'updateSort', 'updatePage'])
</script>

<style src="~layers/app/components/Paginator/Toolbar.css" />
